module.exports = __webpack_public_path__ + "static/media/md-arrow-dropdown-circle.fc0c4c1e.svg";